import { render, staticRenderFns } from "./friendTransfer.vue?vue&type=template&id=3072162b&scoped=true"
import script from "./friendTransfer.vue?vue&type=script&lang=js"
export * from "./friendTransfer.vue?vue&type=script&lang=js"
import style0 from "./friendTransfer.vue?vue&type=style&index=0&id=3072162b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3072162b",
  null
  
)

export default component.exports